import { timeInNormal } from "@/helpers/datetimeHandlers";

function TaskTime({ data }) {
  const start_datetime =
    data.json.start_date || data.json.start_datetime || data.start_datetime;

  return timeInNormal(start_datetime);
}

export default TaskTime;
